import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
export function BeforeAfterGallery() {
  const [activeTab, setActiveTab] = useState<'before' | 'after'>('before');
  const stages = [{
    label: 'Not So Lucky',
    image: 'https://images.squarespace-cdn.com/content/v1/68b1c92980758f249a9819d8/b742e429-d0be-45c0-a79d-0258965c9825/20231222_120556.jpg?format=750w',
    description: 'Starting point'
  }, {
    label: 'Getting There',
    image: 'https://images.squarespace-cdn.com/content/v1/68b1c92980758f249a9819d8/ac4dd5d0-0b05-4eaf-8aaa-4833edfa0263/20231129_123648.jpg?format=750w',
    description: 'Work in progress'
  }, {
    label: 'Feeling Lucky',
    image: 'https://images.squarespace-cdn.com/content/v1/68b1c92980758f249a9819d8/757d2088-86ab-4267-899c-a742460c584f/20250825_143945.jpg?format=750w',
    description: 'Beautiful transformation'
  }];
  return <div className="space-y-8" data-id="element-25">
      {/* Eyebrow + Headline */}
      <div className="text-center mb-8" data-id="element-26">
        <p className="text-sm font-medium text-[#8BA888] mb-3" data-id="element-27">
          From Worn-Out to Wow
        </p>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-28">
          You Know You Deserve This
        </h2>
        <p className="text-gray-600" data-id="element-29">
          And yes… lucky ducks actually get it. 😉
        </p>
      </div>

      {/* Image Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-30">
        {stages.map((stage, index) => <div key={index} className="relative group" data-id="element-31">
            <div className="relative overflow-hidden rounded-lg shadow-lg aspect-[3/4]" data-id="element-32">
              <img src={stage.image} alt={stage.description} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105" data-id="element-33" />
              {/* Label Badge */}
              <div className="absolute top-4 left-4" data-id="element-34">
                <span className="inline-block px-4 py-1.5 rounded-full text-xs font-bold bg-white text-gray-900 shadow-md" data-id="element-35">
                  {stage.label}
                </span>
              </div>
            </div>
            {/* Description */}
            <p className="text-center text-sm text-gray-600 mt-3" data-id="element-36">
              {stage.description}
            </p>

            {/* Arrow indicator between stages */}
            {index < stages.length - 1 && <div className="hidden md:block absolute top-1/2 -right-3 z-10 transform -translate-y-1/2" data-id="element-37">
                <div className="bg-[#8BA888] rounded-full p-2 shadow-lg" data-id="element-38">
                  <ArrowRight className="h-4 w-4 text-white" data-id="element-39" />
                </div>
              </div>}
          </div>)}
      </div>

      {/* Micro-copy */}
      <p className="text-center text-gray-600 text-sm mt-6" data-id="element-40">
        This is what a stress-free bathroom remodel looks like.
      </p>

      {/* CTA Button */}
      <div className="text-center mt-8" data-id="element-41">
        <button className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border-2 border-[#8BA888] text-[#8BA888] hover:bg-[#8BA888]/10 transition-colors font-medium" data-id="element-42">
          See More Lucky Transformations
          <ArrowRight className="h-4 w-4" data-id="element-43" />
        </button>
      </div>
    </div>;
}